import * as React from "react";
import {useEffect, useState} from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {ContainerBox} from "myshubhlife-component/container-box";
import {ACCEPT_TYPE, COLOR} from "utils/variables";
import {IScreens} from "IncompleteInfoV2/interface";
import {pageTitle, ScreenNames} from "IncompleteInfoV2/utils";
import DocInput, {DocTypes} from "myshubhlife-component/docInput";
import {getContentType} from "userform/utils";
import {DocUploadModes} from "loan-application/utils";
import {updateSubStatuses, uploadDocument} from "IncompleteInfoV2/api";
import {removeCompletedSubStatus, showToast} from "IncompleteInfoV2/actions";
import Loading from "components/loading";
import {docTypeMapWithSubStatus} from "IncompleteInfoV2/OtherDocuments/utils";
import "./style.scss";
import {Button} from "web-com";
import {Redirect} from "react-router-dom";
import {indexPath} from "IncompleteInfoV2/routes";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    screens: IScreens;
    isAndroid: boolean;
    applicationId: number;
}

const OtherDocuments = (props: IConnectProps & RouteComponentProps) => {
    const [loading, setLoading] = useState(false);
    const [isUploaded, setIsUploaded] = useState<{[key: string]: boolean}>(null);
    const [error, setError] = useState<{[key: string]: string}>(null);
    const [redirect, setRedirect] = useState(false);
    const allDocsStatuses = props.screens && props.screens[ScreenNames.OTHER_DOCS] && props.screens[ScreenNames.OTHER_DOCS].subStatuses;
    const isCompleted = () => isUploaded && Object.keys(isUploaded).every((status) => isUploaded[status] === true);
    useEffect(() => {
        if (allDocsStatuses) {
            allDocsStatuses.forEach((item, index) => {
                setIsUploaded((prevState) => {
                    return {
                        ...prevState,
                        [docTypeMapWithSubStatus[item].docType]: false,
                    };
                });
            });
        }
    }, []);
    const handleFileUpload = async (imageB64: string, docType: DocTypes) => {
        setError(null);
        const fileType = getContentType(imageB64);
        const docPayload = {
            imageB64,
            userId: props.userId,
            docMode: DocUploadModes.SCAN_UPLOAD,
            docType,
            contentType: fileType.mime,
        };
        try {
            setLoading(true);
            const uploadResponse = await uploadDocument(docType, docPayload);
            if (uploadResponse.status === 200) {
                setIsUploaded({...isUploaded, [docType]: true});
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            setError({[docType]: "Something wrong, please try again"});
        }
    };
    const handleSubmit = async () => {
        if (isCompleted()) {
            try {
                setLoading(true);
                const removeSubStatus = await updateSubStatuses(
                    props.applicationId, props.screens[ScreenNames.OTHER_DOCS].subStatuses,
                );
                if (removeSubStatus.status === 200) {
                    props.dispatch(showToast(COLOR.GREEN, `${pageTitle.documents} updated successfully`));
                    props.dispatch(removeCompletedSubStatus(ScreenNames.OTHER_DOCS));
                    setLoading(false);
                    setRedirect(true);
                }
            } catch (e) {
                setLoading(false);
            }
        }
    };
    return redirect ?
        <Redirect to={`${indexPath}`}/> :
        <ContainerBox
            backgroundColor={COLOR.WHITE}
            pageTitle={pageTitle.documents}
            showBackButton={!props.isAndroid}
        >
            <Loading active={loading} msg="Please wait while uploading"/>
            {
                props.screens[ScreenNames.OTHER_DOCS] &&
                props.screens[ScreenNames.OTHER_DOCS].subStatuses.map((status, index) => {
                    return(
                        <div className="doc-upload-container" key={index}>
                            <DocInput
                                primaryLabel={docTypeMapWithSubStatus[status].heading}
                                secondaryLabel={docTypeMapWithSubStatus[status].desc}
                                type={docTypeMapWithSubStatus[status].docType}
                                handleFileInput={handleFileUpload}
                                compressionRequired={true}
                                isUploaded={isUploaded && isUploaded[docTypeMapWithSubStatus[status].docType]}
                                acceptType={`${ACCEPT_TYPE.PDF},${ACCEPT_TYPE.ALL_IMAGE}`}
                            />
                            {
                                error && <p className="error">{error[docTypeMapWithSubStatus[status].docType] || ""}</p>
                            }
                        </div>
                    );
                })
            }
            <Button
                buttonText="Continue"
                onClick={handleSubmit}
                bgColor={COLOR.PRIMARY}
                width={"60%"}
                isDisabled={!isCompleted()}
            />
        </ContainerBox>;
    };

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        userId: state.login.auth.userId,
        screens: state.incompleteInfoV2.screens,
        isAndroid: state.login.isAndroid,
        applicationId: state?.profileInfo?.latestStatus?.applicationId,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(OtherDocuments);
